import { PORTFOLIO } from '../data';
import './About.css';

function About() {
  const sentences = PORTFOLIO.about.split('. ');

  return (
    <section id="about" className="section">
      <div className="section__head" data-reveal>
        <h2 className="section__title">About Me</h2>
      </div>

      <div className="about">
        {sentences.map((sentence, i) => (
          <p className="about__sentence" data-reveal key={i} style={{ '--d': `${i * 0.08}s` }}>
            {sentence}
            {i < sentences.length - 1 ? '.' : ''}
          </p>
        ))}
      </div>
    </section>
  );
}

export default About;
